import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, catchError, map, filter, exhaustMap, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { GetUsersPlansSummaryUseCase } from '@domain/usecases/user/get-users-plans-summary.usecase';
import { AlertsService } from '@shared/services/alerts/alerts.service';
import { UsersPlansSummaryActions } from '../actions/users-plans-summary.actions';
import { hideLoader, showLoader } from '../actions/loader.actions';
import { UsersPlansSummarySelectors } from '../selectors/users-plans-summary.selectors';

@Injectable()
export class UsersPlansSummaryEffects {

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly getUsersPlansSummaryUseCase: GetUsersPlansSummaryUseCase,
    private readonly alertService: AlertsService
  ) {}

  loadUsersPlansSummary$ = createEffect(() => this.actions$
    .pipe(
      ofType(UsersPlansSummaryActions.loadUsers),
      switchMap((action) => action.force ?? false 
        ? of(false) 
        : this.store.select(UsersPlansSummarySelectors.selectIsLoaded)
      ),
      filter(isLoaded => !isLoaded),
    )
    .pipe(
      tap(() => this.store.dispatch(showLoader())),
      mergeMap(() => this.store.select(UsersPlansSummarySelectors.selectFiltersAndPaginatedData)),
      exhaustMap(params => this.getUsersPlansSummaryUseCase.execute({
        ...params.filter,
        ...params.pagination,
      })),
      map(paginatedUsers =>  UsersPlansSummaryActions.loadUsersSuccess({ pagination: paginatedUsers })),
      catchError((error) => {
        this.alertService.showAlertError('Ocurrió un error al cargar los usuarios. Por favor, intenta nuevamente.');
        console.error('Error: ', error);
        return of(UsersPlansSummaryActions.loadUsersFailure({ error }))
      }),
      tap(() => {
        this.store.dispatch(hideLoader());
      }),
    )
  );
}
